// Runs before the bar markup, while the main theme utilities may still be deferred.
(() => {
  const section = document.currentScript?.closest('.shopify-section');
  if (!section || window.Shopify?.designMode) return;

  try {
    const key = `announcement-marquee-dismissed-${section.id}`;
    // Use the same session key as theme.storageUtil, including its cc- prefix.
    const dismissed = window.theme?.storageUtil
      ? window.theme.storageUtil.get(key, false, true)
      : sessionStorage.getItem(`cc-${key}`);
    if (dismissed === '1') section.classList.add('sc-announcement-marquee--dismissed');
  } catch { /* Leave the announcement visible when session storage is unavailable. */ }
})();
